import useUserStore from "../stores/userStore";

const AUTH_INTERCEPTOR_SKIP_URLS = ["/verify", "/logout_user"];

let sessionLogoutPromise: Promise<void> | null = null;

export const shouldSkipAuthInterceptor = (url?: string): boolean =>
  !!url && AUTH_INTERCEPTOR_SKIP_URLS.some((path) => url.includes(path));

export const performSessionLogout = (): Promise<void> => {
  if (sessionLogoutPromise) {
    return sessionLogoutPromise;
  }

  sessionLogoutPromise = (async () => {
    try {
      await useUserStore.getState().logout();
    } catch (error) {
      console.error("Logout failed:", error);
    } finally {
      if (!window.location.pathname.startsWith("/login")) {
        window.location.href = "/login";
      }
      sessionLogoutPromise = null;
    }
  })();

  return sessionLogoutPromise;
};
